import request from '@/service/request'

/* 根据桌球室id获取台球桌 page
* @params {string} snookerRoomId 桌球室id
* */
export const pageSnookerTableApi = (params) => {
  return request.post('/stu/snookerRoomTable/pageBySnookerRoomId', params)
}

/* 台球桌，list
* @params {string} snookerRoomId 台球桌id
* */
export const listSnookerTableApi = (params = {}) => {
  return request.post('/stu/snookerRoomTable/listBySnookerRoomId', params)
}

/* 台球桌，根据id获取
* @params
* */
export const getSnookerTableByIdApi = (id) => {
  return request.post(`/stu/snookerTable/get/${id}`)
}

/* 台球桌，根据id删除
* @params
* */
export const delSnookerTableApi = (id) => {
  return request.post(`/stu/snookerRoomTable/del/${id}`)
}

/* 台球桌，保存
* @params
* */
export const saveSnookerTableApi = (params) => {
  return request.post('/stu/snookerRoomTable/save', params)
}

/* 台球桌，批量禁用
* @params {array} snookerRoomIds 桌球室id list
* */
export const batchDisableSnookerTableApi = (params) => {
  return request.post('/stu/snookerRoomTable/offBatch', params)
}
